export const AMENITY_GROUP = [
    {
        name: "double_bed",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Doublebed.png`,
    },
    {
        name: "tv",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Television.png`,
    },
    {
        name: "refrigerator",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Refrigerator.png`,
    },
    {
        name: "air_conditioner",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Airconditioner.png`,
    },
    {
        name: "oven",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Microwaveoven.png`,
    },
    {
        name: "shower_supplies",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Showersupplies.png`,
    },
    {
        name: "bathtub",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Bathtub.png`,
    },
    {
        name: "bbq",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Barbecue.png`,
    },
    {
        name: "spa",
        url: `${process.env.PUBLIC_URL}/assets/amenity/Spa.png`,
    },
];
